module.exports = __webpack_public_path__ + "files/6eec61e5b4cfd370572849c132f92ba1.svg";